import * as ko from 'knockout';

import IAccountingSoftwarePackage from '../types/IAccountingSoftwarePackage';
import { SupportedAccountingSoftwareType } from '../types/SupportedAccountingSoftware';

import NetSuiteAccountingPackage from './NetSuiteAccountingPackage';
import QuickBooksDesktopAccountingPackage from './QuickBooksDesktopAccountingPackage';
import QuickBooksOnlineAccountingPackage from './QuickBooksOnlineAccountingPackage';
import XeroAccountingPackage from './XeroAccountingPackage';

class AccountingSoftwareService {
  /** All accounting software packages available to the current company */
  public packages = ko.observable([
    new QuickBooksOnlineAccountingPackage(),
    new QuickBooksDesktopAccountingPackage(),
    new XeroAccountingPackage(),
    new NetSuiteAccountingPackage(),
  ] as Array<IAccountingSoftwarePackage>);

  /** Get all accounting software packages available for the current company */
  public GetPackages(): Array<IAccountingSoftwarePackage> {
    return this.packages();
  }

  /** Get a specific (available) accounting software package */
  public GetPackage(id: SupportedAccountingSoftwareType): IAccountingSoftwarePackage | undefined {
    return this.packages().find((p) => p.id === id);
  }
}

const Instance = new AccountingSoftwareService();

export { AccountingSoftwareService };
export { Instance };
